import React from 'react';
import { Modal, Select } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import s from './s.module.less';

const { Option } = Select;

type TTaxDocument = Readonly<{
    id: string;
    name: string;
    issuedOn: string;
    pdfUrl?: string;
}>;

type Props = Readonly<{
    open: boolean;
    onClose: () => void;
}>;

const EMPTY_STATE_IMG = 'https://www.figma.com/api/mcp/asset/a51d0529-3ceb-48a0-a501-0dfbbfc840c1';

function getYearOptions(): number[] {
    const year = new Date().getFullYear();
    return [year, year - 1, year - 2];
}

export default function TaxDocumentsModal({ open, onClose }: Props) {
    const [selectedYear, setSelectedYear] = React.useState<number>(() => new Date().getFullYear());

    // NOTE: No API wired yet. Keep as empty until backend is available.
    const docs: TTaxDocument[] = [];

    const yearOptions = React.useMemo(() => getYearOptions(), []);

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            centered
            width={720}
            destroyOnClose
            className={s.modal}
            closeIcon={<CloseOutlined className={s.closeIcon} />}
        >
            <div className={s.title}>Tax documents</div>
            <div className={s.yearSelect}>
                <Select value={selectedYear} onChange={(v) => setSelectedYear(v)} className={s.select}>
                    {yearOptions.map((y) => (
                        <Option key={y} value={y}>
                            {y}
                        </Option>
                    ))}
                </Select>
            </div>

            {docs.length === 0 ? (
                <div className={s.emptyState}>
                    <div className={s.emptyInner}>
                        <img className={s.emptyImg} src={EMPTY_STATE_IMG} alt="" />
                        <div className={s.emptyText}>There are no tax documents for this year</div>
                    </div>
                </div>
            ) : (
                <div className={s.list}>
                    {docs.map((doc) => (
                        <div className={s.card} key={doc.id}>
                            <div className={s.cardLeft}>
                                <div className={s.docName}>{doc.name}</div>
                                <div className={s.docMeta}>Issued on {doc.issuedOn}</div>
                            </div>
                            <a
                                className={s.downloadLink}
                                href={doc.pdfUrl}
                                target="_blank"
                                rel="noreferrer"
                                onClick={(e) => {
                                    if (!doc.pdfUrl) e.preventDefault();
                                }}
                            >
                                Download PDF
                            </a>
                        </div>
                    ))}
                </div>
            )}
        </Modal>
    );
}
